import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "./Products.css";
import finalBanner from "../../assets/finalbanner.png";

/* IMAGE IMPORTS */
import marine1 from "../../assets/services-16.jpg";
import marine2 from "../../assets/services-15.jpg";
import marine3 from "../../assets/services-14.jpg";
const MarinePumps = () => {
  const products = [
    { id: 1, name: "Naval Grade Standard", img: marine1 },
    { id: 2, name: "Shock Resistant Unit", img: marine2 },
    { id: 3, name: "High Capacity Marine", img: marine3 },
  ];

  return (
    <div className="cyber-root">
      <div className="blueprint-bg" />

      {/* HERO */}
      <section
  className="hud-hero"
  style={{
    backgroundImage: `
      linear-gradient(
        to bottom,
        rgba(143, 182, 243, 0.65), /* light blue overlay (top) */
        rgba(214, 230, 250, 0.55), /* soft blue overlay (middle) */
        rgba(255, 255, 255, 0.75)  /* white overlay (bottom) */
      ),
      url(${finalBanner})
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="hero-content">
   <motion.h1
  className="hero-main-title"
  initial={{ opacity: 0, x: -60 }}
  animate={{ opacity: 1, x: 0 }}
  transition={{ duration: 0.9, ease: "easeOut" }}
>
     MARINE CENTRIFUGAL PUMPS
</motion.h1>

  </div>
</section>

      <div className="dashboard-container">
        {/* SIDEBAR */}
        <aside className="sidebar-nav">
                  <h3>Product Categories</h3>
        
                 <nav className="nav-buttons">
                            <Link to="/products/transformer-oil-pumps">
                              Glandless Transformer Oil Pumps
                            </Link>
                            <Link to="/products/monoblock-pumps">
                              Self-Priming Monoblock Pumps
                            </Link>
                            <Link className="active" to="/products/canned-motor-pumps">
                              Sealless Canned Motor Pumps
                            </Link>
                            <Link to="/products/marine-pumps">Marine Centrifugal Pumps</Link>
                            <Link to="/products/process-pumps">Centrifugal Process Pump</Link>
                          </nav>
        
                  <button className="side-btn">Technical Catalog</button>
                </aside>
        

        {/* MAIN CONTENT */}
        <main className="industrial-panel">
          <h2>Marine Centrifugal Pumps</h2>
<br/>
          {/* DESCRIPTION – NOT A SINGLE WORD CHANGED */}
          <p className="company-description">
            {/* <strong>Marine Centrifugal Pumps</strong><br /><br /> */}
            FLOWTECH Marine pumps will have an inherent degree of shock resistance,
            minimum rugged criterion for naval installations to withstand dynamic
            accelerations.
            <br /><br />
            The inherent shock strengths of the pump is ascertained by calculation
            in accordance with naval standards as specified by the customer.
            <br /><br />
            Marine pumps are designed to perform under extreme conditions while
            the ship is in motion. Marine pumps are designed with minimum noise
            and vibration levels to withstand vibration and sudden shock stresses
            on ships
            <br /><br />
            <strong>Range:</strong> Present range in manufacturing: Standard product
            up to 15HP, under development 100HP. Temperature range: Standard -40
            Deg C to 270 Deg C. Under development up to 350 Deg C
          </p>
<br/>
          {/* MODELS */}
          <section className="product-showcase">
            <h3 className="section-label">Marine Pump Models</h3>
            <br/>

            <div className="product-grid">
              {products.map((p) => (
                <motion.div
                  key={p.id}
                  whileHover={{ y: -8 }}
                  className="pump-card"
                >
                  <div className="img-holder">
                    <img src={p.img} alt={p.name} />
                  </div>
                  <div className="pump-details">
                    <h4>{p.name}</h4>
                                                    <Link to="/products/marine-pumps" onClick={() => window.scrollTo(0, 0)}> 
                    <button className="view-btn">View Datasheet</button>
                  </Link>
                  </div>
                </motion.div>
              ))}
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default MarinePumps;
